import {PropertyEstimateTooltipContainer} from './PropertyEstimateTooltip';
import PropertyEstimateRange from './PropertyEstimateRange';
import PropTypes from 'prop-types';
import {Divider, Segment} from 'semantic-ui-react';
import {getSalesConfidenceFromAvm, getRentalConfidenceFromAvm} from 'lib/AvmUtils';

const hasConfidence = (propertyAvm, isRental) => {
  const confidence = isRental
    ? getRentalConfidenceFromAvm(propertyAvm)
    : getSalesConfidenceFromAvm(propertyAvm);
  return confidence.label !== 'No';
};

const PropertyAvmDisplay = ({propertyAvm, isRental, onCopyToReport}) => {
  return (
    <Segment basic size="massive">
      <Divider hidden/>
      {
        propertyAvm && hasConfidence(propertyAvm, isRental)
          ? <PropertyEstimateTooltipContainer avm={propertyAvm} isRental={isRental} section="Summary" onCopyToReport={onCopyToReport}/>
          : <PropertyEstimateRange avm={propertyAvm} isRental={isRental}/>
      }
    </Segment>
  );
};

PropertyAvmDisplay.propTypes = {
  propertyAvm: PropTypes.object,
  isRental: PropTypes.bool,
  onCopyToReport: PropTypes.func,
};

export default PropertyAvmDisplay;